import { ControlTypes } from '@nx-customer-apps/shared/enums';
import { QuestionGroupBase } from './question-group-base.model';
import { RadioQuestion } from './radio.model';
import { TextboxQuestion } from './textbox.model';
import { QuestionGroupOptions } from '@nx-customer-apps/shared/interfaces';

interface CustomAnswerRadioOptions extends QuestionGroupOptions<[RadioQuestion, TextboxQuestion]> {
    /**
     * Indicates which radio option should have an optional text input
     */
    customAnswerOptionValue: string;
}

export class CustomAnswerRadio extends QuestionGroupBase<[RadioQuestion, TextboxQuestion]> {
    override controlType = ControlTypes.CustomAnswerRadio;
    public customAnswerOptionValue: string;
    constructor(questionOptions: CustomAnswerRadioOptions) {
        super(questionOptions);
        this.customAnswerOptionValue = questionOptions.customAnswerOptionValue;
    }
}
